const ringToPts = (ring) => ring.map(([lng, lat]) => [lat, lng]).filter((p) => Number.isFinite(p[0]) && Number.isFinite(p[1]));
const dedupeClose = (pts) => (pts.length > 2 && pts[0][0] === pts[pts.length - 1][0] && pts[0][1] === pts[pts.length - 1][1] ? pts.slice(0, -1) : pts);

function fromGeoJSON(text) {
  const gj = JSON.parse(text);
  const feats = gj.type === "FeatureCollection" ? gj.features : gj.type === "Feature" ? [gj] : [{ type: "Feature", geometry: gj, properties: {} }];
  const outList = [];
  feats.forEach((f, i) => {
    const g = f.geometry; if (!g) return;
    const name = f.properties?.name || f.properties?.Name || f.properties?.khasra || `Imported ${i + 1}`;
    const base = { name: String(name).slice(0, 80), color: f.properties?.color || "#2563EB", line_style: f.properties?.line_style || "solid", weight: f.properties?.weight || 3, fill: true };
    if (g.type === "Polygon") outList.push({ ...base, points: dedupeClose(ringToPts(g.coordinates[0])), closed: true });
    else if (g.type === "MultiPolygon") g.coordinates.forEach((poly, j) => outList.push({ ...base, name: `${base.name} (${j + 1})`, points: dedupeClose(ringToPts(poly[0])), closed: true }));
    else if (g.type === "LineString") outList.push({ ...base, points: ringToPts(g.coordinates), closed: false });
    else if (g.type === "MultiLineString") g.coordinates.forEach((ls, j) => outList.push({ ...base, name: `${base.name} (${j + 1})`, points: ringToPts(ls), closed: false }));
  });
  return outList;
}

function fromKML(text) {
  const doc = new DOMParser().parseFromString(text, "application/xml");
  if (doc.querySelector("parsererror")) throw new Error("Invalid KML");
  const parseCoords = (s) => ringToPts(s.trim().split(/\s+/).map((t) => t.split(",").map(Number)));
  const outList = [];
  doc.querySelectorAll("Placemark").forEach((pm, i) => {
    const name = pm.querySelector("name")?.textContent?.trim() || `Imported ${i + 1}`;
    const styleId = pm.querySelector("styleUrl")?.textContent?.trim().replace(/^#/, "");
    const styleEl = styleId ? doc.querySelector(`Style[id="${styleId}"]`) : null;
    const kmlColor = (pm.querySelector("LineStyle > color") || styleEl?.querySelector("LineStyle > color"))?.textContent?.trim();
    const color = kmlColor && kmlColor.length === 8 ? `#${kmlColor.slice(6, 8)}${kmlColor.slice(4, 6)}${kmlColor.slice(2, 4)}` : "#7C3AED";
    const base = { name: name.slice(0, 80), color, line_style: "solid", weight: 3, fill: true };
    pm.querySelectorAll("Polygon > outerBoundaryIs coordinates, Polygon outerBoundaryIs > LinearRing > coordinates").forEach((c) => outList.push({ ...base, points: dedupeClose(parseCoords(c.textContent)), closed: true }));
    pm.querySelectorAll("LineString > coordinates").forEach((c) => outList.push({ ...base, points: parseCoords(c.textContent), closed: false }));
  });
  return outList;
}

export async function parseBoundaryFile(file) {
  const text = await file.text();
  const ext = file.name.split(".").pop().toLowerCase();
  const list = ext === "kml" ? fromKML(text) : fromGeoJSON(text);
  const valid = list.filter((d) => d.points.length >= 2);
  if (!valid.length) throw new Error("No polygon or line boundaries found in the file");
  return valid.slice(0, 200);
}
